import ChangePassword from "../components/change-password/ChangePassword";
import Dashboard from "../components/dashboard/Dashboard";
import ForgotPassword from "../components/forgot-password/ForgotPassword";
import Home from "../components/home/Home";
import { EditProfile } from "../components/profile";
import SignUp from "../components/signup/SignUp";

export const customeRoutesLayout = [
    {
        path: '/change-password',
        element: ChangePassword,
    },
    {
        path: '/edit-profile',
        element: EditProfile,
    },
    {
        path: '/dashboard',
        element: Dashboard,
    }
]

export const customRouteNoLayout = [
    {
        path: '/forgot-password',
        element: ForgotPassword,
        isAuthenticate: false,
    },
    {
        path: '/signup',
        element: SignUp,
        isAuthenticate: false,
    },
    {
        path: '/',
        element: Home,
        isAuthenticate: false
    }
]